import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "@env/environment";
import { INotification, UserType } from "../interfaces";

@Injectable()
export class NotificationService {

    constructor(private http: HttpClient) {

    }

    public Get() {
        return this.http.get<INotification[]>(`${environment.apiUrl}api/notification/get`);
    }

    public MarkAsRead(notificationId: number){
        return this.http.post(`${environment.apiUrl}api/notification/markAsRead`, { data: notificationId });
    }

    public MarkAllNotificationsAsRead(userActiveType : UserType ){
        return this.http.post(`${environment.apiUrl}api/notification/markAllAsRead`, {data:userActiveType});
    }

}
